<div class="ds-grid ds-grid--2">
	<!-- Single Select -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Single Select</h3>
			<p class="ds-example__header-subtitle">Choose one option</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-select
				[label]="'Select Company'"
				[placeholder]="'Choose a company'"
				[options]="simpleOptions"
				[fullWidth]="true"
				(selectionChange)="onSelectionChange('single', $event)">
			</eif-custom-select>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value">
				<div class="ds-value__label">Value:</div>
				<div class="ds-value__content">{{ singleValue || 'No value' }}</div>
			</div>
		</div>
	</div>

	<!-- Multiple Select -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Multiple Select</h3>
			<p class="ds-example__header-subtitle">Choose multiple options</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-select
				[label]="'Select Companies'"
				[placeholder]="'Choose multiple companies'"
				[options]="simpleOptions"
				[multiple]="true"
				[fullWidth]="true"
				(selectionChange)="onSelectionChange('multiple', $event)">
			</eif-custom-select>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value">
				<div class="ds-value__label">Value:</div>
				<div class="ds-value__content">{{ multipleValue || 'No value' }}</div>
			</div>
		</div>
	</div>

	<!-- Disabled Select -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Disabled State</h3>
			<p class="ds-example__header-subtitle">Cannot be modified</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-select
				[label]="'Disabled Select'"
				[placeholder]="'Cannot select'"
				[options]="simpleOptions"
				[disabled]="true"
				[fullWidth]="true">
			</eif-custom-select>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value ds-value--disabled">
				<div class="ds-value__label">Value:</div>
				<div class="ds-value__content">{{ disabledValue || 'No value' }}</div>
			</div>
		</div>
	</div>

	<!-- Select with Validation -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Select with Validation</h3>
			<p class="ds-example__header-subtitle">Requires 2-4 selections, validate on button</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-select
				#validationSelect
				[label]="'Select Companies (2-4)'"
				[placeholder]="'Choose 2 to 4 options'"
				[options]="simpleOptions"
				[multiple]="true"
				[fullWidth]="true"
				[validationRules]="validationRules"
				(selectionChange)="onSelectionChange('validated', $event)"
				(validationChange)="onValidationChange($event)">
			</eif-custom-select>
			<eif-custom-button
				[text]="'Validate'"
				[type]="'button'"
				[size]="'small'"
				[preIcon]="'fa-solid fa-check'"
				(action)="validationSelect.validate()">
			</eif-custom-button>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value">
				<div class="ds-value__label">Value:</div>
				<div class="ds-value__content">{{ validatedValue || 'No value' }}</div>
			</div>
			<div class="ds-value ds-mt-1">
				<div class="ds-value__label">Valid:</div>
				<div class="ds-value__content">{{ validationValid ? 'Yes' : 'No' }}</div>
			</div>
		</div>
	</div>
</div>
